import { createOpenStore } from "stores/createOpenStore";

export const useAccountSettingsStore = createOpenStore<"home" | "delete">();
